var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"condition-content"},[_vm._v(" 缺省组件 ")])}
var staticRenderFns = []

export { render, staticRenderFns }